// store/index.js
import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import auth from './auth';

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        messages: [],
        inputText: '',
        uploadedFile: null
    },
    mutations: {
        SET_MESSAGES(state, messages) {
            state.messages = messages;
        },
        SET_INPUT_TEXT(state, text) {
            state.inputText = text;
        },
        SET_UPLOADED_FILE(state, file) {
            state.uploadedFile = file;
        }
    },
    modules: {
        auth
    },
    plugins: [
        createPersistedState({
            key: 'ai-chat-app',
            paths: ['messages', 'inputText', 'uploadedFile', 'auth'], // 指定需要持久化的状态
            storage: window.localStorage
        })
    ]
});

export default store;
